import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['trigger']

  connect() {
    this.triggerTarget.addEventListener('change', e => { this.element.submit() })
  }
}
